import React from "react";
import "./ProjectEdit.scss";

import { withRouter } from "react-router-dom";

import SectionTitle from "components/SectionTitle";
import Button from "components/Button";

import FormSection from "components/FormSection";
import Input from "components/Input";
import Textarea from "components/Textarea";
import Select from "components/Select";
import MultiSelect from "components/MultiSelect";
import MediaUploadCard from "components/MediaUploadCard";
import { DNDContainer } from "components/DND";

import { Prompt } from "react-router-dom";
import { AuthUserContext, withAuthorization } from "components/Session";
import { withFirebase } from "components/Firebase";
import { compose } from "recompose";
import * as ROUTES from "constants/routes";
import * as OPTIONS from "constants/options";

const editProjectActions = [
  {
    label: "Cancel",
    type: "ghost",
    to: ROUTES.HOMEPAGE
  },
  {
    label: "Save Changes",
    type: "primary"
  }
];

const splitIds = id => {
  return id.split("-");
};

class ProjectEdit extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loaded: false,
      project: {
        id: null,
        likes: 0,
        user: {
          id: "",
          firstName: "",
          lastName: ""
        },
        status: {
          saved: false,
          dirty: false
        }
      },
      form: {
        basicInformation: {
          title: "",
          description: "",
          industry: "",
          client: "",
          clientURL: "",
          completionDate: "",
          category: ""
        },
        images: [
          // {
          //   id: "asdasd",
          //   title: "Example title",
          //   description: "This is a description for the thing",
          //   progress: 20,
          //   image: "https://unsplash.it/480/300"
          // },
          // {
          //   id: "sdslkjfh",
          //   title: "I am title",
          //   description: "Image description to explain project",
          //   progress: 80,
          //   image: "https://unsplash.it/481/300"
          // }
        ],
        descriptions: {
          problem: "",
          audience: "",
          solution: "",
          notes: ""
        },
        tags: {
          skills: [],
          other: []
        }
      }
    };
  }
  handleInputChange = e => {
    const { id, value } = e.target;
    const ids = splitIds(id);

    if (e.target.getAttribute("data-limit")) {
      // Target has a limit
      const limit = parseInt(e.target.getAttribute("data-limit"));
      const { length } = value;
      if (length > limit) return false;
    }

    const { form, project } = this.state;
    form[ids[0]][ids[1]] = value;

    project.status.dirty = true;
    this.setState({ form, project });
  };

  handleMediaInputChange = e => {
    const { id, value } = e.target;
    const ids = splitIds(id);
    const { form, project } = this.state;

    form.images[ids[1]][ids[0]] = value;
    project.status.dirty = true;
    this.setState({ form, project });
  };

  handleMediaReorder = e => {
    if (e.destination) {
      const { source, destination } = e;
      const { form, project } = this.state;
      const item = form.images.splice(source.index, 1);

      form.images.splice(destination.index, 0, item[0]);
      project.status.dirty = true;
      this.setState({ form, project });
    }
  };

  handleMediaDelete = e => {
    e.preventDefault();
    // console.log(e.target.id);
    const { id } = e.target;
    const ids = splitIds(id);
    const { form, project } = this.state;
    form.images.splice(ids[1], 1);
    project.status.dirty = true;
    this.setState({ form, project });
  };

  handleMultiSelectChange = (name, e, limit) => {
    if (e.length > limit) return false;
    const ids = splitIds(name);
    const { form, project } = this.state;
    form[ids[0]][ids[1]] = e;

    project.status.dirty = true;
    this.setState({ form, project });
  };

  handleSelectChange = (name, e) => {
    // console.log(name, e);
    const ids = splitIds(name);
    const { form, project } = this.state;
    form[ids[0]][ids[1]] = e;

    project.status.dirty = true;
    this.setState({ form, project });
  };
  handleSubmit = e => {
    e.preventDefault();
    // const { form } = this.state;
    const { form, project } = this.state;
    // console.log(project);
    this.props.firebase
      .project(project.id)
      .set({
        ...form,
        user: project.user,
        id: project.id,
        likes: project.likes ? project.likes : 0
      })
      .then(() => {
        project.status.dirty = false;
        project.status.saved = true;
        this.setState({ project });
        setTimeout(() => {
          this.props.history.push(`/project/${project.id}`);
        }, 125);
      })
      .catch(error => console.log(error));
  };

  handleProjectDelete = e => {
    e.preventDefault();

    const shouldDelete = prompt(
      "Are you sure? Deleting a project is irreversible. Type DELETE to confirm.",
      ""
    );
    if (shouldDelete && shouldDelete.toLowerCase() === "delete") {
      const { id, user } = this.state.project;
      this.props.firebase
        .project(id)
        .delete()
        .then(() => {
          console.log("Project was successfully deleted");
          this.props.history.push(`/profile/${user.id}`);
        })
        .catch(error => console.error(error));
    }
  };

  handleClickUpload = e => {
    e.preventDefault();
    const fileInput = document.getElementById("media-upload");
    fileInput.click();
  };

  handleImageUpload = e => {
    const { form, project } = this.state;
    const storageRef = this.props.firebase.getStorageRef();
    const imageArray = Array.from(e.target.files);

    // console.log(imageArray);

    imageArray.map((file, i) => {
      const image = {
        title: file.name,
        description: "",
        progress: 0,
        id: null,
        image: ""
      };
      form.images.push(image);
      this.setState({ form });

      const imageRef = storageRef.child(`${project.id}/images/${file.name}`);
      const uploadTask = imageRef.put(e.target.files[i]);

      return uploadTask.on(
        "state_changed",
        snapshot => {
          const progress = Math.floor(
            (snapshot.bytesTransferred / snapshot.totalBytes) * 100
          );
          form.images[i].progress = progress;
          this.setState({ form });
        },
        err => {
          console.error(err);
        },
        () => {
          return imageRef
            .getDownloadURL()
            .then(response => {
              form.images[i].progress = 100;
              form.images[i].id = file.name;
              form.images[i].image = response;
              this.setState({ form });
              return true;
            })
            .catch(error => console.error(error));
        }
      );
    });
  };

  componentDidMount() {
    this.getProject();
  }

  getProject = () => {
    const projectId = this.props.match.params.id;
    this.props.firebase
      .projectExists(projectId)
      .then(response => {
        this.props.firebase
          .projectBelongsToUser(projectId)
          .then(response => {
            const { form, project } = this.state;
            form.basicInformation = response.basicInformation;
            form.images = response.images;
            form.descriptions = response.descriptions;
            form.tags = response.tags;

            project.user = response.user;
            project.id = response.id;
            project.likes = response.likes;

            this.setState({ form, project, loaded: true });
          })
          .catch(error => {
            this.props.history.push("/");
          });
      })
      .catch(error => {
        this.props.history.push("/");
      });
  };

  componentWillUnmount() {}
  render() {
    const { dirty, saved } = this.state.project.status;
    const { basicInformation, descriptions, images } = this.state.form;

    const uploadAction = (
      <Button onClick={this.handleClickUpload} type="primary">
        + Upload Image
      </Button>
    );
    return (
      <AuthUserContext.Consumer>
        {authUser => (
          <div className="ProjectEdit" data-loaded={this.state.loaded}>
            <Prompt when={dirty} message="Are you sure you want to leave?" />
            <form onSubmit={this.handleSubmit}>
              <div style={{ margin: "auto", width: 960 }}>
                <br />
                <br />
                <br />
                <br />
                <SectionTitle title="Edit Project">
                  {editProjectActions &&
                    editProjectActions.map((action, i) => {
                      if (action.type === "primary") {
                        return (
                          <Button
                            disabled={!dirty && !saved}
                            key={i}
                            type={action.type}
                          >
                            {saved && !dirty ? "Saved" : action.label}
                          </Button>
                        );
                      }
                      return (
                        <Button
                          onClick={() => this.props.history.goBack()}
                          key={i}
                          type={action.type}
                        >
                          {action.label}
                        </Button>
                      );
                    })}
                </SectionTitle>
                <br />
                <br />
                <FormSection title="Basic Information">
                  <Input
                    type="text"
                    label="Title"
                    required
                    name="basicInformation-title"
                    onChange={this.handleInputChange}
                    value={basicInformation.title}
                    placeholder="Action statements make great headlines! Ex: New Branding Helps Modernize Real Estate Company"
                  />
                  <Textarea
                    required
                    onChange={this.handleInputChange}
                    value={basicInformation.description}
                    name="basicInformation-description"
                    label="Description"
                    placeholder="Think cliff notes when describing your role. Ex: Leading brand planning, I was responsible for competitor, consumer, and company research. Using this data, I crafted insights that allowed the creative team to reposition and drastically improve our client's brand."
                    limit={1000}
                  />
                  <section>
                    <Select
                      onChange={this.handleSelectChange}
                      value={basicInformation.industry}
                      label="Industry"
                      options={OPTIONS.INDUSTRIES}
                      name="basicInformation-industry"
                    />
                    <Select
                      onChange={this.handleSelectChange}
                      name="basicInformation-category"
                      options={OPTIONS.SKILLS}
                      value={basicInformation.category}
                      label="Role Function"
                    />
                  </section>
                  <section>
                    {/* <Select
                      onChange={this.handleSelectChange}
                      name="basicInformation-completionDate"
                      value={basicInformation.completionDate}
                      label="Completion Date"
                    /> */}
                    <Input
                      onChange={this.handleInputChange}
                      type="text"
                      required
                      name="basicInformation-client"
                      placeholder="Company name"
                      label="Company name"
                      value={basicInformation.client}
                    />
                    <Input
                      onChange={this.handleInputChange}
                      type="url"
                      required
                      name="basicInformation-clientURL"
                      placeholder="Company URL"
                      label="Company URL"
                      value={basicInformation.clientURL}
                    />
                  </section>
                </FormSection>
                <FormSection title="Project Images" action={uploadAction}>
                  {images.length === 0 ? (
                    <div className="ZeroImages">
                      <strong>TIP:</strong> We recommend uploading at least 4
                      images!
                    </div>
                  ) : null}
                  <input
                    multiple
                    onChange={this.handleImageUpload}
                    type="file"
                    accept="image/png, image/jpeg, image/gif"
                    id="media-upload"
                    style={{ display: "none" }}
                  />
                  <DNDContainer
                    id="project-images"
                    onDragEnd={this.handleMediaReorder}
                  >
                    {images &&
                      images.map((image, i) => (
                        <MediaUploadCard
                          onChange={this.handleMediaInputChange}
                          onClickDelete={this.handleMediaDelete}
                          key={i}
                          index={i}
                          {...image}
                        />
                      ))}
                  </DNDContainer>
                </FormSection>
                <FormSection title="Critical Thinking">
                  <Textarea
                    onChange={this.handleInputChange}
                    name="descriptions-problem"
                    value={descriptions.problem}
                    label="Problem"
                    placeholder="In less than 1000 characters, what problem were you or your team trying to solve? Ex: Our client, although a successful and established company, was struggling to acquire younger demographics, specifically first and second time home buyers. This is a huge problem because our client's previous success stemmed from lifetime customers who bought and sold multiple homes over the course of two or three decades. Because the client's business model and brand had fallen behind, new 'tech-enabled' companies have quickly acquired customer trust and business."
                    limit={1000}
                  />
                  <Textarea
                    onChange={this.handleInputChange}
                    name="descriptions-audience"
                    value={descriptions.audience}
                    label="Target Audience"
                    placeholder="Tell us a short description of who you and your team were targeting. Ex: Younger home buyer and sellers. Typically, professionals aged 27-35. Recently, married and, in some cases, expecting their first child."
                    limit={1000}
                  />
                  <Textarea
                    onChange={this.handleInputChange}
                    name="descriptions-solution"
                    value={descriptions.solution}
                    label="Solution"
                    placeholder="In less than 1000 characters, how did you and your team solve the problem? Ex: In my research, I realized that most young professionals relied on family members to help navigate the process of purchasing their first home. Since our client's customers are predominantly older parents, I recommended we focus on increasing the rate of referral from older to younger generations. This required additional business operation updates (e.g. making sure younger real estate agents represented younger customers). Additionally, the creative team crafted a look-and-feel and messaging that spoke directly to the generational transition."
                    limit={1000}
                  />
                  <Textarea
                    onChange={this.handleInputChange}
                    name="descriptions-notes"
                    value={descriptions.notes}
                    label="Additional Notes"
                    placeholder="This is a great place to add some results, if there are any to be shared! Ex: After launching the brand, we saw a 30% uptick in referral volume when compared to the previous year. Of those referrals, we calculated that 80% were first or second time home buyers or sellers! Feedback on the new branding has been great. Old and new clients like the style and messaging, specifically commenting on the fun personality that pokes fun at the entire real estate process."
                    limit={1000}
                  />
                </FormSection>
                <FormSection title="Skills">
                  <MultiSelect
                    options={OPTIONS.SKILLS}
                    onChange={this.handleMultiSelectChange}
                    name="tags-skills"
                    label="primary"
                    value={this.state.form.tags.skills}
                    limit={3}
                  />
                  <MultiSelect
                    options={OPTIONS.SKILLS}
                    onChange={this.handleMultiSelectChange}
                    name="tags-other"
                    label="Secondary"
                    value={this.state.form.tags.other}
                    limit={5}
                  />
                </FormSection>
                <FormSection title="Danger Zone!">
                  <Button onClick={this.handleProjectDelete} type="danger">
                    Delete Project
                  </Button>
                </FormSection>
                <SectionTitle title="">
                  {editProjectActions &&
                    editProjectActions.map((action, i) => {
                      if (action.type === "primary") {
                        return (
                          <Button
                            disabled={!dirty && !saved}
                            key={i}
                            type={action.type}
                          >
                            {saved && !dirty ? "Saved" : action.label}
                          </Button>
                        );
                      }
                      return (
                        <Button
                          onClick={() => this.props.history.goBack()}
                          key={i}
                          type={action.type}
                        >
                          {action.label}
                        </Button>
                      );
                    })}
                </SectionTitle>
                <br />
                <br />
                <br />
                <br />
              </div>
            </form>
          </div>
        )}
      </AuthUserContext.Consumer>
    );
  }
}

const condition = authUser => !!authUser;

export default compose(
  withFirebase,
  withRouter,
  withAuthorization(condition)
)(ProjectEdit);
